import { useSessionContext } from '../context';
import type { SessionStateMutations } from '../stateContext';

export function useSessionMutations(): SessionStateMutations {
	return useSessionContext().mutations;
}
